import { Box, Button, CircularProgress, Container, } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaymentAPIService } from "../../services/api";
import { Table, Tag, Input, Space } from 'antd';
import { formatCurrency, formatDateTime, formatStripeDateTime } from "../../shared/utils";

export default function PaymentDetails() {
  const { phone,customerId } = useParams();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, [customerId]);

  async function load() {
    try {
      const res = await PaymentAPIService.getPaymentsByPhone(customerId);
      setRecords(res || []);
    } catch (error) {
      console.log(" error", error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (records.length === 0) {
    return <Box display="flex" justifyContent="center" alignItems="center" height="50vh">No records found</Box>;
  }

  const columns = [
    {
      title: "S. No.",
      key: "index",
      render: (_text, _record, index) => index + 1,
      width: "10%",
    },
    {
      title: "Payment On",
      dataIndex: 'created',
      render: (_, { created }) => (
        <span>{formatStripeDateTime(created)}</span>
      ),
    },
    {
      title: "Amount",
      dataIndex: 'amount',
      width:"20%",
      render: (_, { amount ,currency = "usd" }) => (
              <span>{formatCurrency(amount, currency)}</span>
            ),
    },
    {
      title: "Card details",
      width:"20%",
      render: (_, record) => (
       <div style={{display:"grid"}}>
              <span>{record?.payment_method_details?.card?.brand}</span>
              <span> XXXX - XXXX - XXXX -{record?.payment_method_details?.card?.last4}</span>
              </div>
            ),
    },
    {
      title: "Status",
      dataIndex: 'status',
      width:"20%",
    },
    {
      title:"Reciept View",
      dataIndex:'receipt_url',
      render:(_,{receipt_url})=>(
        <a href={receipt_url} target="_blank"><Button>View Reciept</Button></a>
      )
    }
  ];

  return (
    <Container>
      <h2>Payment Details for {phone}</h2>
      <Table
  className="custom-table"
  columns={columns}
  dataSource={records}
  onRow={(record) => ({
    onClick: () => {
      // navigate(`/admin/user/${record?.phone}`, { state: { data: record } });
    },
  })}
  rowClassName="clickable-row"
/>
    </Container>
  );
}